<div class="container container-wrapper">
  <div class="row justify-content-center">
    <div class="col-12 col-xl-11">
      <h2 class="title">{{ schedulePlanTitle | translate }}</h2>
    </div>
  </div>
  <div>
    <app-schedule-list></app-schedule-list>
  </div>
  <div *ngIf="schedulePlanDescription" class="row justify-content-center">
    <div class="col-12 col-xl-11">
      <h4 class="title" [innerHtml]="schedulePlanDescription"></h4>
    </div>
  </div>
</div>